import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Participantes',
    path: '/gestao/gesparticipante',
    name: 'gestao/gesparticipante',
    component: () => import('@/views/gestao/gesparticipante/Index.vue'),
    meta: {
      permissions: [eTipoPermissao.PARTICIPANTESNOVO_MENU_2100200299],
    },
    goesToMenu: true,
  },
  {
    description: 'Cadastro de Participantes',
    path: '/gestao/gesparticipante/cadastro/:id?',
    parent: 'gestao/gesparticipante',
    name: 'gestao/gesparticipante_create',
    component: () => import('@/views/gestao/gesparticipante/InclusaoEdicao.vue'),
    meta: { permissions: [eTipoPermissao.PARTICIPANTESNOVO_MENU_2100200299] },
    goesToMenu: true,
  },
];
